import {
	FormControl,
	Grid,
	IconButton,
	MenuItem,
	Select,
	TextField,
} from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTrendingContext } from "../context/TrendingContext";
import CustomOptionsComponent from "../customOptionsComponent";
import { CustomOptions } from "../models/TrendingModels";
import { useTrendingStyles } from "../styles/TrendingStyles";
import { dateNavigator } from "../utils/dateNavigator";

interface Props {
	setChartOptions: (options: any) => void;
}
export const Header = ({ setChartOptions }: Props) => {
	const classes = useTrendingStyles();
	const { state, actions } = useTrendingContext();

	const [customOptions, setCustomOptions] = useState<CustomOptions>({
		showGrid: true,
		stepped: false,
	});

	const handleDateNavigator = (
		operator: "add" | "subtract",
		current = false,
	) => {
		const newDates = dateNavigator(
			state.timeScopeStart,
			state.timeScopeEnd,
			state.scope,
			operator,
			current,
		);
		if (newDates) {
			actions.setTotalScope({
				start: newDates.newStartDate,
				end: newDates.newEndDate,
				scope: state.scope,
			});
		}
	};

	const handleDateChange = (newValue: any, key: "start" | "end") => {
		//@ts-ignore
		actions.setTotalScope({ [key]: moment(newValue).toDate() });
	};

	const handleChangeScope = (e: any) => {
		const newScope = e.target.value;
		actions.setTotalScope({
			scope: newScope,
		});
	};

	useEffect(() => {
		const changeOptions = () => {
			setChartOptions((prevOptions: any) => {
				const newScales = { ...prevOptions.scales };

				Object.keys(newScales).forEach((key) => {
					if (key) {
						newScales[key] = {
							...newScales[key],
							grid: {
								...newScales[key].grid,
								display: customOptions.showGrid,
							},
						};
					}
				});

				return {
					...prevOptions,
					elements: {
						line: {
							stepped: customOptions.stepped,
							lineTension: 0.1,
						},
					},
					scales: newScales,
				};
			});
		};

		changeOptions();
	}, [customOptions]);

	useEffect(() => {
		setChartOptions((prevOptions: any) => ({
			...prevOptions,
			scales: {
				...prevOptions.scales,
				x: {
					...prevOptions.scales.x,
					min: state.timeScopeStart.getTime(), // Establece el mínimo del eje X
					max: state.timeScopeEnd.getTime(), // Establece el máximo del eje X
				},
			},
		}));
	}, [state.timeScopeStart, state.timeScopeEnd]);

	return (
		<Grid
			item
			xs={12}
			container
			justifyContent="space-between"
			alignItems="center"
			style={{ height: "15%" }}
		>
			<Grid
				md={6}
				item
				container
				justifyContent="flex-start"
				alignItems="center"
				wrap={"wrap"}
			>
				<Grid item>
					<IconButton
						color="primary"
						onClick={() => handleDateNavigator("subtract")}
						className={classes.navigatorButton}
					>
						<ChevronLeft fontSize="large" />
					</IconButton>
				</Grid>

				<Grid item>
					<TextField
						type="datetime-local"
						className={classes.datetimePicker}
						label="Start"
						variant="outlined"
						value={moment(state.timeScopeStart).format("YYYY-MM-DDTHH:mm:ss")}
						onChange={(e) => handleDateChange(e.target.value, "start")}
						InputLabelProps={{
							shrink: true,
							style: { marginLeft: "10px" },
						}}
						InputProps={
							{
								max: state.timeScopeEnd,
							} as any
						}
					/>
				</Grid>
				<Grid item className={classes.select}>
					<FormControl variant="outlined">
						<Select
							value={state.scope}
							onChange={handleChangeScope}
							displayEmpty
						>
							<MenuItem value="10 min">10 min</MenuItem>
							<MenuItem value="1 hour">1 hour</MenuItem>
							<MenuItem value="4 hours">4 hours</MenuItem>
							<MenuItem value="12 hours">12 hours</MenuItem>
							<MenuItem value="1 day">1 day</MenuItem>
							<MenuItem value="10 days">10 days</MenuItem>
							<MenuItem value="custom">Custom</MenuItem>
						</Select>
					</FormControl>
				</Grid>
				<Grid item>
					<TextField
						label="End"
						variant="outlined"
						className={classes.datetimePicker}
						type="datetime-local"
						value={moment(state.timeScopeEnd).format("YYYY-MM-DDTHH:mm:ss")}
						onChange={(e) => handleDateChange(e.target.value, "end")}
						InputLabelProps={{
							shrink: true,
							style: { marginLeft: "10px" },
						}}
					/>
				</Grid>
				<Grid item>
					<IconButton
						onClick={() => handleDateNavigator("add")}
						className={`${classes.navigatorButton}`}
					>
						<ChevronRight fontSize="large" />
					</IconButton>
				</Grid>
				<Grid item>
					<IconButton
						onClick={() => handleDateNavigator("subtract", true)}
						className={`${classes.navigatorButton}`}
					>
						<SkipNextIcon fontSize="large" />
					</IconButton>
				</Grid>
			</Grid>

			<Grid md={6} item container justifyContent="space-between">
				<Grid item container wrap="nowrap" spacing={1}>
					<Grid item container>
						<CustomOptionsComponent
							customOptions={customOptions}
							setCustomOptions={setCustomOptions}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};
